<template>
  <div class="jj-form">
    <!-- <div class="tips-text">(企业注册时间超过三年必须填写最近三年经济数据，企业注册时间不足三年，请填写注册当年到去年所有数据)</div> -->
    <el-row :gutter="0">
      <!-- <el-form
        ref="elForm"
        :model="formData"
        :rules="rules"
        size="small"
        label-width="165px"
      >
        <el-col :span="8">
          <el-form-item label="知识产权" prop="yysr">
            <el-input
              v-model="formData.yysr"
              placeholder="知识产权(万元)"
              clearable
              :style="{ width: '100%' }"
              :disabled="tijBtnShow == false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="专利总数" prop="zyywsr">
            <el-input
              v-model="formData.zyywsr"
              placeholder="请输入专利数量"
              clearable
              :style="{ width: '100%' }"
              :disabled="tijBtnShow == false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发明专利" prop="xssr">
            <el-input
              v-model="formData.xssr"
              placeholder="请输入发明专利数量"
              clearable
              :style="{ width: '100%' }"
              :disabled="tijBtnShow == false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="使用新型专利" prop="jlr">
            <el-input
              v-model="formData.jlr"
              placeholder="请输入使用新型专利数量"
              clearable
              :style="{ width: '100%' }"
              :disabled="tijBtnShow == false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="外观专利" prop="jzc">
            <el-input
              v-model="formData.jzc"
              placeholder="请输入外观专利"
              clearable
              :style="{ width: '100%' }"
              :disabled="tijBtnShow == false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="软件著作权" prop="zzc">
            <el-input
              v-model="formData.zzc"
              placeholder="请输入软件著作权"
              clearable
              :style="{ width: '100%' }"
              :disabled="tijBtnShow == false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item size="large">
            <el-button
              v-show="tijBtnShow == true"
              type="primary"
              @click="submitForm"
              >{{
                formData.year &&
                formData.year == 2020 - parseInt(activeName) &&
                formData.id
                  ? "修改"
                  : "新建"
              }}</el-button
            >
            <el-button @click="tijBtnShow = !tijBtnShow" type="danger">{{
              tijBtnShow ? "取消" : "编辑"
            }}</el-button>
          </el-form-item>
        </el-col>
      </el-form> -->
      <el-form
        :model="formData.zscq"
        size="small"
        label-width="144px"
        class="jjzbform"
        ref="zscqForm"
      >
        <el-col :span="12">
          <el-form-item label="知识产权总数" prop="zscqzs">
            <el-input
              v-model="formData.zscq.zscqzs"
              placeholder="请输入总资产"
              :disabled="tijBtnShow == false"
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="专利总数" prop="zlzs">
            <el-input
              v-model.number="formData.zscq.zlzs"
              placeholder="请输入专利总数"
              :disabled="tijBtnShow == false"
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册商标总数" prop="zcsbzs">
            <el-input
              v-model.number="formData.zscq.zcsbzs"
              placeholder="请输入注册商标总数"
              :disabled="tijBtnShow == false"
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="软件著作总数" prop="rjzzzs">
            <el-input
              v-model.number="formData.zscq.rjzzzs"
              placeholder="请输入软件著作总数"
              :disabled="tijBtnShow == false"
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item size="large">
            <el-button
              v-show="tijBtnShow == true"
              type="primary"
              @click="saveCompanyData"
            >{{ addUpStatus == 0 ? "新增" : "修改" }}</el-button
            >
            <el-button @click="tijBtnShow = !tijBtnShow" type="danger">{{
                tijBtnShow ? "取消" : "编辑"
              }}</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: [],
  data() {
    return {
      /* tabs */
      activeName: "0",
      /* 是否编辑 */
      tijBtnShow: false,
      /* 展示参数 */
      formData: {
        zscq: {},
      },
      /* 暂存三年的 */
      newData: {
        yysr: "",
        zyywsr: "",
        xssr: "",
        jlr: "",
        jzc: "",
        zzc: "",
        ckze: "",
        jkze: "",
        fzze: "",
        ml: "",
        yftl: "",
        zdxmtz: "",
        nsze: "",
        qnsze: "",
        nszm: "",
        qysds: "",
        zzs: "",
        yysr: "",
        zrsds: "",
        qts: "",
        bz: "",
        createTime: "",
        updateTime: "",
        // webEid: '',
        year: "", // 年份
      },
      addUpStatus:0,
      /* 获取的所有列表参数 */
      allFormList: [],
      rules: {
        yysr: [
          {
            required: true,
            message: "请输入营业收入(万元)",
            trigger: "blur",
          },
        ],
        zyywsr: [],
        xssr: [
          {
            required: true,
            message: "请输入销售收入(万元)",
            trigger: "blur",
          },
        ],
        jlr: [
          {
            required: true,
            message: "请输入净利润",
            trigger: "blur",
          },
        ],
        jzc: [
          {
            required: true,
            message: "请输入净资产",
            trigger: "blur",
          },
        ],
        zzc: [
          {
            required: true,
            message: "请输入总资产",
            trigger: "blur",
          },
        ],
        ckze: [],
        jkze: [
          {
            required: true,
            message: "请输入进口总额",
            trigger: "blur",
          },
        ],
        fzze: [
          {
            required: true,
            message: "请输入负债总额",
            trigger: "blur",
          },
        ],
        ml: [
          {
            required: true,
            message: "请输入毛利",
            trigger: "blur",
          },
        ],
        yftl: [
          {
            required: true,
            message: "请输入研发投入",
            trigger: "blur",
          },
        ],
        zdxmtz: [],
        nsze: [
          {
            required: true,
            message: "请输入纳税总额",
            trigger: "blur",
          },
        ],
        qnsze: [
          {
            required: true,
            message: "请输入区纳税总额",
            trigger: "blur",
          },
        ],
        nszm: [],
        qysds: [],
        zzs: [],
        yysr: [],
        zrsds: [],
        qts: [],
        bz: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      userBaseInfo: "getUserInfo",
      accountId: "getAccountId",
      getDictList: "dictionary/getDictList",
    }),
  },
  watch: {},
  created() {
    this.formData.webEid = this.userBaseInfo.id;
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "sys_regType", // 企业性质
      ],
    });
    this.getCompanydetails();
  },
  mounted() {},
  methods: {
    saveCompanyData() {
      let url = "/dev-api/enterprise/baseInfo/perfectEnterpriseInfo";
      let params = JSON.parse(JSON.stringify(this.formData));
      if (params.gwjjfl.length > 1) {
        params.gwjjfl = params.gwjjfl.join(",");
      } else {
        params.gwjjfl = params.gwjjfl.toString();
      }
      if (params.cylx.length > 1) {
        params.cylx = params.cylx.join(",");
      } else {
        params.cylx = params.cylx.toString();
      }
      if (params.enterpriseQualification.length > 1) {
        params.enterpriseQualification =
          params.enterpriseQualification.join(",");
      } else {
        params.enterpriseQualification =
          params.enterpriseQualification.toString();
      }
      this.$httpApi
        .post(url, params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "提交成功！",
              type: "success",
            });
            this.tijBtnShow = false;
            this.$parent.getInfoByShxydm();
          } else if (res.code === 500) {
            this.$message({
              message: `${res.msg}`,
              type: "error",
            });
          }
        })
        .catch((e) => {});
    },
    getCompanydetails() {
      let url = "/dev-api/enterprise/baseInfo/getEnterpriseByShxydm";
      this.$httpApi
        .get(url, { shxydm: this.userBaseInfo.tyshxydm })
        .then((res) => {
          if (res.code === 200) {
            const _that = this;
            // let stringList = ["rzqd", "qyyd"];
            let target = JSON.parse(JSON.stringify(res.data));
            this.addUpStatus = target ? "1" : "0"; // 1 是修改 0 是新增
            for (const [k, v] of Object.entries(target)) {
              if (v === "null") {
                target[k] = "";
              }
            }
            // for (const i in target) {
            //   for (const item of stringList) {
            //     if (i.indexOf(item) !== -1) {
            //       target[i] = _that.transformSA(target[i]);
            //       // console.log(">>>>", i)
            //     }
            //   }
            // }

            //市级区划回显
            if (Number(target.xzqh1) == "411100000000") {
              target.xzqh1 = [411100000000];
            }
            //区级区划回显
            else if (
              Number(target.xzqh1) == Number(target.xzqh2) &&
              Number(target.xzqh2) == Number(target.xzqh3)
            ) {
              target.xzqh1 = [411100000000, Number(target.xzqh1)];
            }
            //街道级区划回显
            else if (
              Number(target.xzqh1) != Number(target.xzqh2) &&
              Number(target.xzqh2) == Number(target.xzqh3)
            ) {
              target.xzqh1 = [
                411100000000,
                Number(target.xzqh1),
                Number(target.xzqh2),
              ];
            }
            //居委会级区划回显
            else {
              target.xzqh1 = [
                411100000000,
                Number(target.xzqh1),
                Number(target.xzqh2),
                Number(target.xzqh3),
              ];
            }
            console.log("列表清洗后的数据>>>", target);
            this.$store.commit("updateAccountId", target.id);
            this.formData = Object.assign(this.formData, target);
          }
        })
        .catch((e) => {});
    },
    /**
     * 新建经济指标
     */
    addJJZB() {
      this.tijBtnShow = false;
    },
    /**
     * 修改
     */
    upJJZB() {
      this.tijBtnShow = false;
    },
    /**
     * tabs 切换
     */
    handleClick(tab, event) {
      console.log("切换>>>", tab.label, event);
      const e = parseInt(tab.index);
      this.formData = this.threeYearData[e]; // 初始
      this.formData.year = tab.label;
    },
    /**
     * 提交按钮
     */
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        // TODO 提交表单
        if (this.formData.id) {
          this.upJJZB();
        } else {
          this.addJJZB();
        }
      });
    },
    /**
     * 重置按钮
     */
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.jj-form {
}
.tips-text {
  // position: absolute;
  right: 0;
  top: 18px;
}
</style>
<style lang="scss">
.jj-form {
  .el-tabs__nav {
    height: 40px !important;
  }
}
</style>
